import React from "react";
import { Box } from "@mui/material";
import MainSection from "./MainSection";
import AboutSection from "./AboutSection";
import VersSection from "./VersSection";
import LocationSection from "./LocationSection";
import FillialsSection from "./FillialsSection";
import EventSection from "./EventSection";
import ExpiredEventSection from "./ExpiredEventSection";

const Landing = ({ scrollToSection }) => {
  return (
    <Box overflow="hidden">
      <MainSection scrollToSection={scrollToSection} />
      <AboutSection/>
      <VersSection/>
      <EventSection/>
      <ExpiredEventSection/>
      <FillialsSection/>
      <LocationSection/>
    </Box>
  );
};

export default Landing;
